import { useEffect, useState, React } from "react";

import axios from "axios";
import { useAuthContext } from "../../../Hooks/useAuthContext";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Libraries
import { Form, InputGroup } from "react-bootstrap";
import moment from "moment/moment";

export default function OrderFilter({ filterOrders }) {
    const navigate = useNavigate()

    const [agents, setAgents] = useState([]);

    const [form, setForm] = useState({
        name: "",
        code: "",
        location: "",
        dateGreaterThan: "",
        dateLessThan: "",
        assignedAgentId: ""
    });

    const { user } = useAuthContext();

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    function submitClicked() {
        filterOrders(form);
    }

    // On Load
    useEffect(() => {

        axios
            .get(`https://${process.env.REACT_APP_IP}/api/users/`,
                {
                    headers: { Authorization: `bearer ${user.token}` },
                })
            .then((res) => {
                console.log("Users:", res.data);
                setAgents(res.data);
            })


    }, [])


    return (
        <div className="filterBox">
            <div className="row">
                <div className="col-12">
                <h5>Filter Options</h5>
                </div>
            </div>
            

            <div className="row">

                { /* Account Code */}
                <div className="form-group col-2">
                    <label>Account Code</label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="e.g ABC123"
                        onChange={(e) => setField("code", e.target.value)}

                    />
                </div>

                { /* Name */}
                <div className="form-group col-4">
                    <label>Name</label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="e.g John Smith"
                        onChange={(e) => setField("name", e.target.value)}

                    />
                </div>

                { /* Assigned Agent */}
                <div className="form-group col-4">
                    <label>Assigned Agent</label>
                    <Form.Select
                        onChange={(e) => setField("assignedAgentId", e.target.value)}
                        style={{ flex: 1 }}
                    >
                        <option value="">Any Agents</option>
                        <option value="0">No Agent Assigned</option>
                        <option disabled>-----------------</option>
                        {agents && (agents.map((agent) => {
                            return <option key={agent.id} value={agent.id}>{agent.name}</option>
                        }))}
                    </Form.Select>
                </div>

                { /* Location */}
                <div className="form-group col-2">
                    <label>Location</label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="e.g CA1"
                        onChange={(e) => setField("location", e.target.value)}

                    />
                </div>

                

                
            
                
            </div>

            <div className="row">
                { /* Date - Greater Than */}
                <div className="form-group col-3">
                    <label>Last Order Date</label>
                    <InputGroup>
                        <InputGroup.Text>After</InputGroup.Text>

                        <Form.Control
                            required
                            type="date"
                            placeholder="e.g 25/03/2025"
                            onChange={(e) => setField("dateGreaterThan", e.target.value)}
                            value={form && form.dateGreaterThan}
                        />
                    </InputGroup>
                </div>

                { /* Date - Less Than */}
                <div className="form-group col-3">
                    <label>Last Order Date</label>
                    <InputGroup>
                        <InputGroup.Text>Before</InputGroup.Text>

                        <Form.Control
                            required
                            type="date"
                            placeholder="e.g 25/03/2025"
                            onChange={(e) => setField("dateLessThan", e.target.value)}

                        />
                    </InputGroup>
                </div>

                <div className="form-group col-1">
                    <br />
                    <button className="btn btn-primary" onClick={submitClicked}>Filter</button>
                </div>
            </div>
                    
                
        </div>
    )
}
